import * as React from "react"
import { IconProps } from "./models"

export const PackageIcon: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 19.425V12.575L5 9.1V15.95L11 19.425ZM13 19.425L19 15.95V9.1L13 12.575V19.425ZM11 21.725L4 17.7C3.68333 17.5167 3.43767 17.275 3.263 16.975C3.08833 16.675 3.00067 16.3417 3 15.975V8.025C3 7.65833 3.08767 7.325 3.263 7.025C3.43833 6.725 3.684 6.48333 4 6.3L11 2.275C11.3167 2.09167 11.65 2 12 2C12.35 2 12.6833 2.09167 13 2.275L20 6.3C20.3167 6.48333 20.5627 6.725 20.738 7.025C20.9133 7.325 21.0007 7.65833 21 8.025V15.975C21 16.3417 20.9127 16.675 20.738 16.975C20.5633 17.275 20.3173 17.5167 20 17.7L13 21.725C12.6833 21.9083 12.35 22 12 22C11.65 22 11.3167 21.9083 11 21.725ZM16 8.525L17.925 7.425L12 4L10.05 5.125L16 8.525ZM12 10.85L13.95 9.725L8.025 6.3L6.075 7.425L12 10.85Z"
      fill={color}
    />
  </svg>
)
